// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".C2rdB7XFj0_8Bw6XmRyi {\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n  width: 300px;\n}\n", "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".Logo {\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n  width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Logo": "C2rdB7XFj0_8Bw6XmRyi"
};
export default ___CSS_LOADER_EXPORT___;
